import React, {Suspense} from 'react'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

import App from './App'
import 'native/native-bridge';
//import './index.css'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      suspense: false,
    },
  },
})

// PROD 빌드환경에서 console 기능 Disabled
if (process.env.REACT_APP_NODE_ENV === 'qa' || process.env.REACT_APP_NODE_ENV === 'production') {
  console.log = function () {}
  console.info = function () {}
  console.warn = function () {}
  console.error = function () {}
}

ChartJS.register(ArcElement, Tooltip, Legend) // chart.js

console.log('빌드 : ' + process.env.REACT_APP_NODE_ENV)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <RecoilRoot>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div></div>}>
        <BrowserRouter>
          <App />
          {process.env.REACT_APP_NODE_ENV === 'local' && (
            <ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />
          )}
        </BrowserRouter>
      </Suspense>
    </QueryClientProvider>
  </RecoilRoot>,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
